import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatOdds, formatPercent } from './utils';

const formatEvValue = (value) => {
  if (value === undefined || value === null || Number.isNaN(Number(value))) return '-';
  return Number(value).toFixed(2);
};

const formatEdgeValue = (value) => {
  if (value === undefined || value === null || Number.isNaN(Number(value))) return '-';
  const num = Number(value);
  return `${num >= 0 ? '+' : ''}${num.toFixed(2)}`;
};

function EvBetPanel({
  bets,
  eyebrow = 'VALUE BETS',
  title = '期待値以上の買い目',
  emptyText = '期待値以上の買い目なし',
}) {
  return (
    <Box className="race-detail-panel">
      <Typography className="race-detail-section-eyebrow">{eyebrow}</Typography>
      <Typography className="race-detail-section-title">{title}</Typography>

      {!bets?.length ? (
        <Typography sx={{ mt: 2.5, color: 'rgba(203, 229, 245, 0.72)' }}>{emptyText}</Typography>
      ) : (
        <TableContainer className="race-detail-table-shell" sx={{ mt: 2.5 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>買い目</TableCell>
                <TableCell align="right">オッズ</TableCell>
                <TableCell align="right">推定確率</TableCell>
                <TableCell align="right">期待値</TableCell>
                <TableCell align="right">エッジ</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bets.map((bet) => (
                <TableRow key={`${bet.combo}-${bet.rank || 0}`} hover>
                  <TableCell>{bet.combo || '-'}</TableCell>
                  <TableCell align="right">{formatOdds(bet.odds)}</TableCell>
                  <TableCell align="right">{formatPercent(bet.pHatPct, 1)}</TableCell>
                  <TableCell align="right">{formatEvValue(bet.ev)}</TableCell>
                  <TableCell align="right">{formatEdgeValue(bet.edge)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default EvBetPanel;
